import { DataSet } from './../../engenharia/projetos/projetos-layout/projetos-layout.model';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  ITipoPessoa,
  PessoaForm,
  PessoaPost,
  PessoaPut,
} from './cadastrar-pessoa-layout.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ViaCepService } from '../../../services/viacep/viacep.service';
import { PermissionService } from '../../../services/permission.service';
import { HttpService } from '../../../services/common/http/common.http.service';
import { FileRead } from '../../../components/drag-drop/drag-drop.model';
import {
  formatDate,
  formatDateForInput2,
} from '../../../utils/utility-functions';
import Swal from 'sweetalert2';
import { AppExportBase64 } from '../../../services/exportBase64/exportBase64.service';
import { IDocumentoModalData } from '../modal-documento-layout/modal-documento-layout.model';

type IEtapas = 1 | 2 | 3 | 4 | 5 | 6;
@Component({
  selector: 'app-cadastrar-pessoa-layout',
  templateUrl: './cadastrar-pessoa-layout.component.html',
  styleUrls: ['./cadastrar-pessoa-layout.component.scss'],
})
export class CadastrarPessoaLayoutComponent implements OnInit {
  permission: number = 2;
  etapa: IEtapas = 1;
  totalEtapas: number = 6;
  isMode: boolean = false;
  loader: boolean = false;
  isCepSearching: boolean = false;
  documentoModalData: IDocumentoModalData = {};
  visibleModalDocumento: boolean = false;

  constructor(
    private httpService: HttpService,
    private permissionService: PermissionService,
    private exportBase64Service: AppExportBase64,
    private viaCepService: ViaCepService,
    private activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.permission = this.permissionService.getPermission();
    this.activateRoute();
    this.getTipoPessoas();
    this.changeDetectorRef.detectChanges();
  }

  form: PessoaForm = {
    numeroFichaRegistro: '',
    tipoContratacao: 0,
    nomeCompleto: '',
    nomeMae: '',
    nomePai: '',
    rg: '',
    cpf: '',
    dataNascimento: '',
    localNascimento: '',
    documentoMilitar: '',
    ctps: '',
    cor: null,
    sexo: null,
    grauInstrucao: null,
    cep: '',
    endereco: '',
    numeroResidencia: 0,
    cidade: '',
    estado: '',
    telefone: '',
    email: '',
    cnh: '',
    categoriaCnh: null,
    tituloEleitor: '',
    numeroReservista: '',
    numeroCarteiraTrabalho: '',
    numeroPisPasep: '',
    dataAdmissao: '',
    dataDemissao: '',
    localTrabalho: '',
    estadoCivil: 1,
    turno: 1,
    valorHora: 0,
    cargaHoraria: 176,
    valorSalario: 1518,
    valorComissao: 0,
    possuiDeficiencia: false,
    deficiencia: '',
    titularBancario: '',
    tipoConta: null,
    banco: '',
    agencia: '',
    numeroConta: 0,
    digitoConta: 0,
    fotoPessoa: '',
    fotoPessoaNm: '',
    atestadoEscolaridade: '',
    exameAdmissional: '',
    carteiraTrabalho: '',
    previdenciaSocial: '',
    certidaoNascimento: '',
    certidaoCasamento: '',
    valeTransporte: '',
    servicoMilitar: '',
    descricaoSalario: '',
  };

  tipoContratacaoOptions = [];

  mockedSelectData = [
    {
      name: 'Alimentícia',
      value: 'alimenticia',
    },
    {
      name: 'Construção',
      value: 'construcao',
    },
  ];

  categoriaCnhOptions = [
    {
      name: 'A',
      value: 1,
    },
    {
      name: 'B',
      value: 2,
    },
    {
      name: 'AB',
      value: 3,
    },
    {
      name: 'C',
      value: 4,
    },
    {
      name: 'D',
      value: 5,
    },
    {
      name: 'E',
      value: 6,
    },
  ];

  grauInstituicaoOptions = [
    {
      name: 'Fundamental incompleto',
      value: 1,
    },
    {
      name: 'Fundamental completo',
      value: 2,
    },
    {
      name: 'Médio incompleto',
      value: 3,
    },
    {
      name: 'Médio completo',
      value: 4,
    },
    {
      name: 'Superior incompleto',
      value: 5,
    },
    {
      name: 'Superior Completo',
      value: 6,
    },
    {
      name: 'Pós graduação incompleta',
      value: 7,
    },
    {
      name: 'Pós graduação completa',
      value: 8,
    },
  ];

  sexoOptions = [
    {
      name: 'Masculino',
      value: 1,
    },
    {
      name: 'Feminino',
      value: 2,
    },
    {
      name: 'Outro',
      value: 3,
    },
  ];

  tipoContaOptions = [
    {
      name: 'Depósito',
      value: 1,
    },
    {
      name: 'Pagamento',
      value: 2,
    },
    {
      name: 'Corrente',
      value: 3,
    },
    {
      name: 'Poupança',
      value: 4,
    },
    {
      name: 'Salário',
      value: 5,
    },
    {
      name: 'Digital',
      value: 6,
    },
  ];

  estadoCivilOptions = [
    {
      name: 'Solteiro',
      value: 1,
    },
    {
      name: 'Casado',
      value: 2,
    },
    {
      name: 'Viúvo',
      value: 3,
    },
    {
      name: 'Divorciado',
      value: 4,
    },
    {
      name: 'União Estável',
      value: 5,
    },
  ];

  turnoOptions = [
    {
      name: 'Manhã',
      value: 1,
    },
    {
      name: 'Tarde',
      value: 2,
    },
    {
      name: 'Noite',
      value: 3,
    },
  ];

  possuiDeficienciaOptions = [
    {
      name: 'Sim',
      value: true,
    },
    {
      name: 'Não',
      value: false,
    },
  ];

  corOptions = [
    {
      name: 'Preto',
      value: 1,
    },
    {
      name: 'Branca',
      value: 2,
    },
    {
      name: 'Pardo',
      value: 3,
    },
    {
      name: 'Indígena',
      value: 4,
    },
    {
      name: 'Outro',
      value: 5,
    },
  ];

  editando: boolean = false;

  idPessoa: number = 0;

  proximaEtapa() {
    if (this.etapa < this.totalEtapas) {
      this.etapa++;
    }
  }

  etapaAnterior() {
    if (this.etapa > 0) {
      this.etapa--;
    }
  }

  cadastrarPessoa() {
    this.loader = true;
    const payload = this.createPayload();

    if (!this.editando) {
      this.httpService.usePost('PessoaWithDocuments', payload).add(() => {
        this.loader = false;
      });
    } else {
      payload.ImagemPessoa = {
        ...payload.ImagemPessoa,
        PessoaId: this.idPessoa,
      };

      const payloadPut: PessoaPut = {
        ...payload,
        IdPessoa: this.idPessoa,
      };

      this.httpService.usePut('PessoaWithDocuments', payloadPut).add(() => {
        this.loader = false;
      });
    }
  }

  valorHora() {
    const valorHora =
      this.form.cargaHoraria == 0
        ? 0
        : Number(this.form.valorSalario) / Number(this.form.cargaHoraria);
    this.form.valorHora = Math.round(valorHora * 100) / 100;
  }

  createPayload(): PessoaPost | PessoaPut {
    return {
      IdPessoa: 1,
      TxFichaRegistro: this.form.numeroFichaRegistro,
      TxNome: this.form.nomeCompleto,
      TipoPessoaId: this.form.tipoContratacao,
      TxNomeMae: this.form.nomeMae,
      TxNomePai: this.form.nomePai,
      TxRG: this.form.rg,
      TxCPF: String(this.form.cpf),
      DtNascimento: new Date(this.form.dataNascimento),
      TxLocalNascimento: this.form.localNascimento,
      TxDocumentoMilitar: this.form.documentoMilitar,
      TxCTPS: this.form.ctps,
      NuCor: Number(this.form.cor),
      TxSexo: Number(this.form.sexo),
      NuCEP: Number(this.form.cep),
      TxEndereco: this.form.endereco,
      NuResidencia: Number(this.form.numeroResidencia),
      TxCidade: this.form.cidade,
      TxEstado: this.form.estado,
      TxTelefone: this.form.telefone,
      TxEmail: this.form.email,
      TxCNH: this.form.cnh,
      NuCategoria: Number(this.form.categoriaCnh),
      TxTituloEleitor: this.form.tituloEleitor,
      TxReservista: this.form.numeroReservista,
      TxCarteiraTrabalho: this.form.numeroCarteiraTrabalho,
      TxPISPASEP: this.form.numeroPisPasep,
      DtAdmissao: new Date(this.form.dataAdmissao),
      DtDemissao: new Date(this.form.dataDemissao),
      TxLocalTrabalho: this.form.localTrabalho,
      NuEstadoCivil: Number(this.form.estadoCivil),
      NuTurnoPessoa: Number(this.form.turno),
      NuValorHora: Number(this.form.valorHora),
      NuCargaHora: Number(this.form.cargaHoraria),
      NuSalario: Number(this.form.valorSalario),
      NuComissao: Number(this.form.valorComissao),
      TxDescricaoSalario: this.form.descricaoSalario,
      FlDeficiencia: Boolean(this.form.possuiDeficiencia),
      TxTipoDeficiencia: this.form.deficiencia,
      TxTituloBancario: this.form.titularBancario,
      NuTipoContaBanco: Number(this.form.tipoConta),
      TxBanco: this.form.banco,
      TxAgenciaBanco: String(this.form.agencia),
      NuContaBanco: Number(this.form.numeroConta),
      NuDigitoContaBanco: Number(this.form.digitoConta),
      NuEscolaridade: Number(this.form.grauInstrucao),
      ImagemPessoa: {
        TxImagemPessoa: this.form.fotoPessoa,
        NmImagemPessoa: String(this.form.fotoPessoaNm),
      },
      DocumentosPessoa: {
        TxImagemEscolaridade: this.form.atestadoEscolaridade,
        TxImagemCarteiraTrabalho: this.form.carteiraTrabalho,
        TxImagemCTPS: this.form.previdenciaSocial,
        TxImagemCertificadoNascimento: this.form.certidaoNascimento,
        TxImagemCertificadoCasamento: this.form.certidaoCasamento,
        TxImagemDeclaracaoTransporte: this.form.valeTransporte,
        TxImagemServicoMilitar: this.form.servicoMilitar,
        TxImagemDeclaracaoSaude: this.form.exameAdmissional,
      },
    };
  }

  getTipoPessoas() {
    this.loader = true;

    this.httpService.useGet('TipoPessoa').subscribe({
      next: (response: any) => {
        this.tipoContratacaoOptions = response.DataSet.map(
          (item: ITipoPessoa) => {
            return {
              value: item.IdTipoPessoa,
              name: item.TxDenominacao,
            };
          }
        );
        this.loader = false;
      },
      error: (_error: any) => {
        this.loader = false;
      },
    });
  }

  onFileDropped(field: string, file: FileRead) {
    const formattedBase64 = file.base64.replace(
      /^data:image\/jpeg;base64,/,
      ''
    );

    if (field == 'fotoPessoa') {
      this.form.fotoPessoa = formattedBase64;
      this.form.fotoPessoaNm = file.name;
    }
    if (field == 'atestadoEscolaridade') {
      this.form.atestadoEscolaridade = formattedBase64;
    }
    if (field == 'exameAdmissional') {
      this.form.exameAdmissional = formattedBase64;
    }
    if (field == 'carteiraTrabalho') {
      this.form.carteiraTrabalho = formattedBase64;
    }
    if (field == 'previdenciaSocial') {
      this.form.previdenciaSocial = formattedBase64;
    }
    if (field == 'certidaoNascimento') {
      this.form.certidaoNascimento = formattedBase64;
    }
    if (field == 'certidaoCasamento') {
      this.form.certidaoCasamento = formattedBase64;
    }
    if (field == 'valeTransporte') {
      this.form.valeTransporte = formattedBase64;
    }
    if (field == 'servicoMilitar') {
      this.form.servicoMilitar = formattedBase64;
    }
  }

  buscarCep() {
    if (this.form.cep.length === 8 && !this.isCepSearching) {
      this.isCepSearching = true;
      this.loader = true;

      this.viaCepService.GetBuscarCep(this.form.cep, {
        onSuccess: (response: any) => {
          this.form.endereco = `${response.logradouro} - ${response.bairro}`;
          this.form.cidade = response.localidade;
          this.form.estado = response.uf;
          this.loader = false;
          this.isCepSearching = false;
        },
        onError: (error: any) => {
          this.loader = false;
          this.isCepSearching = false;
          Swal.fire({
            title: 'Erro!',
            text: error,
            icon: 'warning',
            confirmButtonText: 'Ok',
            confirmButtonColor: 'green',
          });
        },
      });
    }
  }

  validarEtapa1() {
    if (!this.isMode) {
      if (
        this.form.numeroFichaRegistro.length >= 1 &&
        this.form.nomeCompleto.length >= 3 &&
        (this.form.nomeMae.length >= 2 || this.form.cpf.length === 11)
      ) {
        return true;
      }
      return false;
    }
    return true;
  }

  validarEtapa4() {
    if (!this.isMode) {
      if (this.form.valorHora) {
        return true;
      }
      return false;
    }
    return true;
  }

  validarEtapa5() {
    if (!this.isMode) {
      if (this.form.fotoPessoa) {
        return true;
      }
      return false;
    }
    return true;
  }

  activateRoute() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['editando']) {
        this.isMode = true;
        this.editando = params['editando'] === 'true';
        const IdPessoa = (this.idPessoa = Number(params['idPessoa']));

        this.httpService
          .useGet('PessoaByFilter', { IdPessoa })
          .subscribe((response) => {
            const valueForm = response.DataSet[0];
            (this.form.tipoContratacao = valueForm.TipoPessoaId),
              (this.form.numeroFichaRegistro = valueForm.TxFichaRegistro),
              (this.form.nomeCompleto = valueForm.TxNome),
              (this.form.nomeMae = valueForm.TxNomeMae ?? ''),
              (this.form.nomePai = valueForm.TxNomePai ?? ''),
              (this.form.rg = valueForm.TxRG),
              (this.form.cpf = valueForm.TxCPF ?? ''),
              (this.form.dataNascimento = formatDateForInput2(
                String(valueForm.DtNascimento) ?? ''
              )),
              (this.form.localNascimento = valueForm.TxLocalNascimento ?? ''),
              (this.form.documentoMilitar = valueForm.TxDocumentoMilitar ?? ''),
              (this.form.ctps = valueForm.TxCTPS ?? ''),
              (this.form.cor = Number(valueForm.NuCor) ?? 0),
              (this.form.sexo = Number(valueForm.TxSexo) ?? 0),
              (this.form.grauInstrucao = Number(valueForm.NuEscolaridade) ?? 0),
              (this.form.cep = valueForm.NuCEP ?? ''),
              (this.form.endereco = valueForm.TxEndereco ?? ''),
              (this.form.numeroResidencia = valueForm.NuResidencia ?? 0),
              (this.form.cidade = valueForm.TxCidade ?? ''),
              (this.form.estado = valueForm.TxEstado ?? ''),
              (this.form.telefone = valueForm.TxTelefone ?? ''),
              (this.form.email = valueForm.TxEmail ?? ''),
              (this.form.cnh = valueForm.TxCNH ?? ''),
              (this.form.categoriaCnh = valueForm.NuCategoria ?? 0),
              (this.form.tituloEleitor = valueForm.TxTituloEleitor ?? ''),
              (this.form.numeroReservista = valueForm.TxReservista ?? ''),
              (this.form.numeroCarteiraTrabalho =
                valueForm.TxCarteiraTrabalho ?? ''),
              (this.form.numeroPisPasep = valueForm.TxPISPASEP ?? ''),
              (this.form.dataAdmissao = formatDateForInput2(
                String(valueForm.DtAdmissao) ?? ''
              )),
              (this.form.dataDemissao = formatDateForInput2(
                String(valueForm.DtDemissao) ?? ''
              )),
              (this.form.localTrabalho = valueForm.TxLocalTrabalho ?? ''),
              (this.form.estadoCivil = valueForm.NuEstadoCivil ?? 0),
              (this.form.turno = valueForm.NuTurnoPessoa ?? 0),
              (this.form.valorHora = valueForm.NuValorHora ?? 0),
              (this.form.cargaHoraria = valueForm.NuCargaHora ?? 0),
              (this.form.valorSalario = valueForm.NuSalario ?? 0),
              (this.form.valorComissao = valueForm.NuComissao ?? 0),
              (this.form.possuiDeficiencia = valueForm.FlDeficiencia ?? false),
              (this.form.deficiencia = valueForm.TxTipoDeficiencia ?? ''),
              (this.form.titularBancario = valueForm.TxTituloBancario ?? ''),
              (this.form.tipoConta = valueForm.NuTipoContaBanco ?? 0),
              (this.form.banco = valueForm.TxBanco ?? ''),
              (this.form.agencia = valueForm.TxAgenciaBanco ?? 0),
              (this.form.numeroConta = valueForm.NuContaBanco ?? 0),
              (this.form.digitoConta = valueForm.NuDigitoContaBanco ?? 0),
              (this.form.descricaoSalario = valueForm.TxDescricaoSalario ?? '');
          });

        this.httpService
          .useGet('ImagemPessoa', { IdPessoa: IdPessoa })
          .subscribe({
            next: (response: any) => {
              this.form.fotoPessoa = response.Data;
              this.form.fotoPessoaNm = response.Name;
            },
          });

        for (let i = 1; i <= 8; i++) {
          this.httpService
            .useGet('DocumentoPessoa', {
              IdPessoa: IdPessoa,
              NuTipoDocumento: i,
            })
            .subscribe({
              next: (response: any) => {
                if (response.Name === 'Atestado Escolaridade.jpg') {
                  this.form.atestadoEscolaridade = response.Data ?? '';
                }
                if (response.Name === 'Exame Médico Admissional.jpg') {
                  this.form.exameAdmissional = response.Data ?? '';
                }
                if (response.Name === 'Carteira de Trabalho.jpg') {
                  this.form.carteiraTrabalho = response.Data ?? '';
                }
                if (response.Name === 'Previdência social (CTPS).jpg') {
                  this.form.previdenciaSocial = response.Data ?? '';
                }
                if (response.Name === 'Certidão de nascimento.jpg') {
                  this.form.certidaoNascimento = response.Data ?? '';
                }
                if (response.Name === 'Certidão de casamento.jpg') {
                  this.form.certidaoCasamento = response.Data ?? '';
                }
                if (response.Name === 'Declaração Vale Transporte.jpg') {
                  this.form.valeTransporte = response.Data ?? '';
                }
                if (
                  response.Name === 'Prova de quitação do serviço militar.jpg'
                ) {
                  this.form.servicoMilitar = response.Data ?? '';
                }
              },
            });
        }
      }
    });
    this.changeDetectorRef.detectChanges();
    this.valorHora();
  }

  visualizarDocumento(base64?: string, nomeDocumento?: string): void {
    this.documentoModalData = {
      nomePessoa: this.form.nomeCompleto,
      base64,
      nomeDocumento,
    };
    this.visibleModalDocumento = !this.visibleModalDocumento;
  }

  downloadArquivo(base64: any, name: string): void {
    const arquivo = base64;
    this.exportBase64Service.downloadJPG(arquivo, name);
  }
}
